// extracted by mini-css-extract-plugin
module.exports = {"news":"News_news__dSZKt"};